import { useMutation, type ApolloError } from '@apollo/client';
import type {
  CreateProductSetForPriceCheckerMutation,
  CreateProductSetForPriceCheckerPreviewMutation,
} from 'src/App/generated/graphql-types';
import { createProductSetForPriceCheckerPreviewMutation } from 'src/queries/createProductSet/createProductSetForPriceCheckerPreviewQuery';
import { createProductSetForPriceCheckerMutation } from 'src/queries/createProductSet/createProductSetForPriceCheckerQuery';

const createUseProductSetMutation = (isPreview: boolean) => {
  const mutation = isPreview
    ? createProductSetForPriceCheckerPreviewMutation
    : createProductSetForPriceCheckerMutation;

  return useMutation(mutation, {
    errorPolicy: 'all',
  });
};

export type ProductSetData =
  | CreateProductSetForPriceCheckerMutation['createProductSetForPriceChecker']
  | CreateProductSetForPriceCheckerPreviewMutation['createProductSetForPriceCheckerPreview'];

export const useProductSet = (
  isPreview: boolean,
): {
  useProductSetQuery: ReturnType<typeof createUseProductSetMutation>[0];
  isLoading: boolean;
  error?: ApolloError;
  data?: ProductSetData;
} => {
  const [useProductSetQuery, { data, error, loading }] =
    createUseProductSetMutation(isPreview);

  return {
    useProductSetQuery,
    isLoading: loading,
    error,
    data:
      data?.createProductSetForPriceChecker ??
      data?.createProductSetForPriceCheckerPreview,
  };
};
